import api from "./index";

const BASE = "api/buyer-portal/admin/support-tickets";

// List support tickets — supports { status, inquiry_type, search, page, page_size }
export const getSupportTickets = (params = {}) =>
  api.get(`${BASE}/`, { params });

// Single ticket detail
export const getSupportTicket = (id) =>
  api.get(`${BASE}/${id}/`);

// Update status, admin_notes, or assigned_agent
export const updateSupportTicket = (id, data) =>
  api.patch(`${BASE}/${id}/`, data);
